<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style>

.p-button.p-button-info {
    background: #495057 !important;
    border-color: #495057 !important;
    color: #fff !important;
}
</style>
